/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Remove_Group_AriaInputs */



/**
* | output |
* | --- |
* | "Remove unavailable group" |
*
* @param {Team_Share_Remove_Group_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_remove_group_aria = /** @type {((inputs?: Team_Share_Remove_Group_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Remove_Group_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "de") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "es") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Remove unavailable group")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remove unavailable group")
	return /** @type {LocalizedString} */ ("Remove unavailable group")
});